import { useCallback, useMemo } from "react";
import { mdiEyeOutline } from "@mdi/js";
import Icon from "@mdi/react";
import clsx from "clsx";

import { FILE_TYPE_ICON_LIST } from "constants/loads";
import { formatFileSize } from "helpers/formatFileSize";
import { useUserFeature } from "hooks/useUserFeature";
import { UploadedFile } from "models/Component";
import styles from "./style.module.scss";
import { showErrorMessage } from "helpers/toastMessage";

interface IProps {
  file: UploadedFile;
  hideViewButton?: boolean;
}

export default function UploadItem({ file, hideViewButton = false }: Readonly<IProps>) {
  const { isBroker } = useUserFeature();
  const FileType = useMemo(
    () => FILE_TYPE_ICON_LIST.find((item) => item.type === file.type) ?? FILE_TYPE_ICON_LIST[2],
    [file]
  );

  const previewAttachment = useCallback(() => {
    const newWindow = window.open(file?.url, "_blank");
    if (newWindow) {
      newWindow.focus();
    } else {
      showErrorMessage("Failed to open the window. It might have been blocked by the browser.");
    }
  }, [file]);

  return (
    <div className={styles.uploadedFileCard}>
      <div className={clsx(styles.cardBody, !isBroker && "flex-1")}>
        {FileType.icon({
          className: "flex-none text-primary size-9"
        })}
        <div className={styles.description}>
          <div className={styles.fileInfo}>
            <span className="font-medium break-all">{file.name}</span>
            <span className="text-left text-placeholder">Document Type</span>
          </div>
          <div className={styles.fileInfo}>
            <span className="text-left text-placeholder">{formatFileSize(file.size)}</span>
            <span>{file.fileType.map((item) => item).join(", ")}</span>
          </div>
        </div>
      </div>

      {!hideViewButton ? (
        <div className={styles.cardFooter}>
          <button type="button" className={styles.iconButton} onClick={previewAttachment}>
            <Icon path={mdiEyeOutline} />
          </button>
        </div>
      ) : null}
    </div>
  );
}
